<template>
  <div style="overflow: hidden">
    <transition name="fadeInRight">
      <div
        v-if="pricingDetails !== null"
        v-bind:class="arePriceDetailsEnabled && 'details-active'"
        class="price-label-container"
        @click.stop="onPriceClickHandler"
      >
        {{ cost || '0.00' }}
        <div v-if="arePriceDetailsEnabled" class="price-label-info-icon-container">
          <i class="fa fa-info price-label-info-icon"></i>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import swal from "sweetalert2";
import PricingDetails from "./pricing-details";

export default {
  props: {
    pricingDetails: {
      default: null,
      required: false,
    },
  },
  methods: {
    onPriceClickHandler: async function () {
      if (!this.arePriceDetailsEnabled) return;
      try {
        await swal.fire({
          title: "Details",
          width: "80vw",
          html: '<div id="PricingDetailsRoot" style="overflow-y: scroll;margin-bottom: 50px"></div>',
          focusConfirm: false,
          willOpen: () => {
            this.mountVueComponent();
          },
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.destroyVueComponent();
      }
    },
    mountVueComponent() {
      let ComponentClass = Vue.extend(PricingDetails);
      this.pricingDetailsComponentInstance = new ComponentClass({
        propsData: {
          pricingDetails: this.pricingDetails,
        },
      });
      this.pricingDetailsComponentInstance.$mount();
      document
        .getElementById("PricingDetailsRoot")
        .appendChild(this.pricingDetailsComponentInstance.$el);
    },
    destroyVueComponent() {
      this.pricingDetailsComponentInstance.$destroy();
      this.pricingDetailsComponentInstance = null;
    },
  },
  computed: {
    cost: function () {
      if (!this.pricingDetails || !this.pricingDetails.cost) return;

      return this.pricingDetails.cost.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
    arePriceDetailsEnabled() {
      return this.pricingDetails;
    },
  },
};
</script>

<style scoped>
.fadeInRight-leave-to,
.fadeInRight-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.fadeInRight-leave-active,
.fadeInRight-enter-active {
  transition: all 300ms ease !important;
}
.price-label-container {
  font-size: 3rem;
  position: relative;
  padding-right: 2rem;
  display: inline-block;
  transition: all 100ms ease-in-out;
}

.price-label-container.details-active {
  cursor: pointer;
  color: #3883fa;
}

.price-label-container.details-active:hover {
  color: #3139f2;
  transform: scale(1.05);
}
.price-label-info-icon-container {
  position: absolute;
  top: 2px;
  right: 0;
  border: solid 1px #3883fa;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-style: dashed;
}
.price-label-info-icon {
  font-size: 16px;
}
</style>
